// Nav type
export type navLinkType = {
  label: string;
  url: string;
};

// Nav
const navLinks = [
  {
    label: 'Services',
    url: '#services',
  },
  {
    label: 'Projects',
    url: '#works',
  },
  {
    label: 'About',
    url: '#about-me-section',
  },
  {
    label: 'Testimonials',
    url: '#testimonials-section',
  },
  {
    label: 'Contact',
    url: '#contact-section',
  },
];
const navbarLinks = [
  {
    label: 'Home',
    url: '#app',
  },
  ...navLinks,
];

const socialLinks = [
  
  {
    label: 'GitHub',
    url: 'https://github.com/jslorenzodev',
    target:"_blank"
  },
  {
    label: 'LinkedIn',
    url: 'https://www.linkedin.com/in/jsorenzo/',
    target:"_blank"
  },
];

const resourceLinks = [
  // {
  //   label: 'Pillarstack',
  //   url: 'https://www.pillarstack.com',
  // },
  // {
  //   label: 'Figma Template',
  //   url: 'https://www.figma.com/community/file/1328038510191576951/project-starter-template',
  // },
];

const heroText = 
  'Freelance full-stack developer. Clean code. Real results.';
const locationPlace = `15°22'22.0"N 44°10'39.5"E`;
const locationCountry = 'Philippines';

// cal.com
const dataCalNamespace = '30min';
const dataCalLink = 'john-savar-lorenzo-wt5l4h/30min';
const dataCalConfig =
  '{"layout":"month_view", "theme": "dark", "brand": "#8C8C73"}';

export {
  socialLinks,
  resourceLinks,
  heroText,
  locationPlace,
  locationCountry,
  navLinks,
  navbarLinks,
  dataCalNamespace,
  dataCalLink,
  dataCalConfig,
};
